module.exports = __webpack_public_path__ + "staticcomp/img/content_4.1163c53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/content_4.jpg
// module id = Ww8z
// module chunks = 39